const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_ACTIVITIES)

export const apiLoyaltyActivities = {
	fetchPointsLoyaltyActivities: async (
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IPointLoyaltyActivityModel[]>> => {
		const { data, meta } = await apiCommon<IPointLoyaltyActivity[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { search }),
		})

		return { data: data.map(d => PointsLoyaltyActivity(d)), meta }
	},
	fetchPointsLoyaltyActivity: async (id: number): Promise<IPointLoyaltyActivityModel> => {
		const { data } = await apiCommon<IPointLoyaltyActivity>(`${groupPrefix}/${id}`, { method: 'GET' })

		return PointsLoyaltyActivity(data)
	},
	createPointsLoyaltyActivity: async (
		payload: IPointLoyaltyActivityPayloadCreate,
	): Promise<IPointLoyaltyActivityModel> => {
		const { data } = await apiCommon<IPointLoyaltyActivity>(`${groupPrefix}`, { method: 'POST', body: payload })

		return PointsLoyaltyActivity(data)
	},
	updatePointsLoyaltyActivity: async (
		payload: IPointsLoyaltyActivityPayloadUpdate,
	): Promise<IPointLoyaltyActivityModel> => {
		const { data } = await apiCommon<IPointLoyaltyActivity>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return PointsLoyaltyActivity(data)
	},
	deletePointsLoyaltyActivity: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},
}
